import {delay} from 'redux-saga';
import {takeLatest, call, put} from 'redux-saga/effects';

import {AssignmentApi} from 'static/three-oh/src/modules/apis';

import {assignmentActions} from '../actions';
import * as actions from './../actions/assignmentActions';
import * as types from './../constants/assignmentActionTypes';

function * getAssignments(action) {
  try {
    const data = yield call(AssignmentApi.get, action.queryParams);
    yield put(actions.loadAssignmentsSuccess(data));
  } catch (error) {
    yield put(actions.loadAssignmentsFailure(error));
  }
}

function * pollAssignments(action, initiated = false) {
  let isPollInitiated = initiated;
  while (true) {
    yield put(assignmentActions.requestAssignments(action.params, isPollInitiated));
    yield call(delay, action.delay || 5000);
    isPollInitiated = true;
  }
}

export function * watchGetAssignments() {
  yield takeLatest(types.ASSIGNMENTS_LOAD_REQUEST, getAssignments);
}

export function * watchStartAssignmentsPolling() {
  yield takeLatest(types.START_ASSIGNMENTS_POLLING, pollAssignments);
}
